import React, { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import {
  RecoilRoot,
  atom,
  selector,
  useRecoilState,
  useRecoilValue,
} from "recoil"
import {
  sizeState,
  themeState,
  listObjState,
  userObjState,
  pagesObjState,
  editModeState,
} from "../recoil-atom"

import { DndProvider } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"

import ListMark from "./ListMark"
import LinkMarkDrop from "./LinkMarkDrop"
import LinkMarkEdit from "./LinkMarkEdit"
import { emptyMark } from "../initdata"

import styled, { css } from "styled-components"
const Group = styled.div`
  overflow: hidden;
  padding: 0 5px;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}
  min-width: 360px;
  display: grid;
  grid-template-columns: repeat(${(props) => props.repeatPage}, 1fr);
  justify-items: center;
  align-items: start;
`

const ListGroup = ({ pageId, groupId }) => {
  const [size, setSize] = useRecoilState(sizeState)
  const [theme, setTheme] = useRecoilState(themeState)
  const [listObj, setListObj] = useRecoilState(listObjState)
  const [userObj, setUserObj] = useRecoilState(userObjState)
  const [pagesObj, setPagesObj] = useRecoilState(pagesObjState)
  const [editMode, setEditMode] = useRecoilState(editModeState)

  const groupKey = pageId + groupId

  return (
    <>
      <Group width={size.pageWidth} repeatPage={size.pageItem}>
        {listObj[pageId][groupId].map((mark, index) => (
          <ListMark
            pageId={pageId}
            groupId={groupId}
            markId={index}
            mark={mark}
            key={index}
          />
        ))}
      </Group>
    </>
  )
}

export default ListGroup
